import http from '../http'
import { storageUtil } from '@/utils'

const { getLocalStorage } = storageUtil

export default {
  // 货品分类列表
  useAllList(data: object, option: object = {}) {
    return http.usePost('/product/category/all/list', data, option)
  },
  // 货品列表
  prodList(data: object, option: object = {}) {
    const corpInfo = getLocalStorage('corpInfo', true) || {}
    const { industryId } = corpInfo

    return http.post(
      '/product/mini_custom_cloud/query_by_page',
      {
        ...data,
        industryId,
        unionMall: 0, // 是否过滤联合商城：0和null所有货品 1 过滤联合商城
        interfaceVersion: 1, // 反转productSkuModels与skuDetails，为1时使用productSkuModels，为0时使用skuDetails，不传默认为0
      },
      option,
    )
  },
  // 多货品分享
  getShareProduct(data: object, option: object = {}) {
    return http.post(
      '/product/share_product/list_by_page',
      {
        ...data,
        interfaceVersion: 1,
      },
      option,
    )
  },
  // 货品详情
  prodDetail(data: object, option: object = {}) {
    return http.post(
      '/product/mini_custom_cloud/query_detail',
      {
        ...data,
        interfaceVersion: 1,
      },
      option,
    )
  },

  // 查询首页推荐货品详情
  queryHomeSuggestDetail(data: object, option: object = {}) {
    return http.post(
      '/product/product_v2/cloud_store/query_suggest_module_detail',
      data,
      option,
    )
  },
}
